import axios from "axios";
import { API_BASEURL } from "../utils/baseURL";
import { authHeader } from "../utils/headers";
import {
  newFolderRequest,
  moveFolderRequest,
  renameFolderRequest,
} from "../models/folder";
import { moveVideos } from "../models/video";

export const getAllFolders = async (isRootOnly: boolean) => {
  return await axios
    .get(`${API_BASEURL}v1/folder?isRootOnly=${isRootOnly}`, {
      headers: authHeader(),
    })
    .catch((error) => {
      return error;
    });
};

export const getSubFolders = async (id: string) => {
  return await axios
    .get(`${API_BASEURL}v1/folder/${id}/subfolders`, {
      headers: authHeader(),
    })
    .catch((error) => {
      return error;
    });
};

export const moveFolder = async (id: string, request: moveFolderRequest) => {
  return await axios
    .put(`${API_BASEURL}v1/folder/${id}/move`, request, {
      headers: authHeader(),
    })
    .catch((error) => {
      return error;
    });
};

export const newFolder = async (request: newFolderRequest) => {
  return await axios
    .post(`${API_BASEURL}v1/folder`, request, {
      headers: authHeader(),
    })
    .catch((error) => {
      return error;
    });
};

export const renameFolder = async (
  id: string,
  request: renameFolderRequest,
) => {
  return await axios
    .put(`${API_BASEURL}v1/folder/${id}/rename`, request, {
      headers: authHeader(),
    })
    .catch((error) => {
      return error;
    });
};

export const deleteFolder = async (id: string) => {
  return await axios
    .delete(`${API_BASEURL}v1/folder/${id}`, {
      headers: authHeader(),
    })
    .catch((error) => {
      return error;
    });
};

export const moveVideoToFolder = async (id: string, request: moveVideos) => {
  return await axios
    .post(`${API_BASEURL}v1/folder/${id}/videoIndex/move`, request, {
      headers: authHeader(),
    })
    .catch((error) => {
      return error;
    });
};
